module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gotop",
    style: ({
      display: _vm.show ? 'block' : 'none'
    }),
    on: {
      "click": _vm.goTop
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58ab64f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoTop.vue
// module id = 1087
// module chunks = 85